/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipTermsLender } from './HomeownershipTermsLender';
import {
    HomeownershipTermsLenderFromJSON,
    HomeownershipTermsLenderFromJSONTyped,
    HomeownershipTermsLenderToJSON,
} from './HomeownershipTermsLender';
import type { HomeownershipTermsStatus } from './HomeownershipTermsStatus';
import {
    HomeownershipTermsStatusFromJSON,
    HomeownershipTermsStatusFromJSONTyped,
    HomeownershipTermsStatusToJSON,
} from './HomeownershipTermsStatus';

/**
 * The latest sent, non-superseded version of the resident terms. Non-binding.
 * 
 * The fee and lender fields (TXN-3383) are null / empty on versions approved before they were snapshotted.
 * `buyer_agent_fee_*`: what the owner pays the resident's agent, if they use one (a percent of the value, and
 * in dollars). The seller always pays it; it is never part of the price or credit (TXN-3496).
 * `appraisal_fee_payer`: `buyer` (the resident) or `owner` (who funds a desktop appraisal, up to $250).
 * @export
 * @interface HomeownershipTermsBlock
 */
export interface HomeownershipTermsBlock {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    listPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    residentPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    closingCredit?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    discountPct?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    splitPct?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    validUntilDate?: string;
    /**
     * 
     * @type {HomeownershipTermsStatus}
     * @memberof HomeownershipTermsBlock
     */
    status: HomeownershipTermsStatus;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    response?: HomeownershipTermsBlockResponseEnum;
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipTermsBlock
     */
    respondedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    buyerAgentFeePct?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    buyerAgentFeeAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsBlock
     */
    appraisalFeePayer?: HomeownershipTermsBlockAppraisalFeePayerEnum;
    /**
     * 
     * @type {Array<HomeownershipTermsLender>}
     * @memberof HomeownershipTermsBlock
     */
    lenders?: Array<HomeownershipTermsLender>;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipTermsBlock
     */
    lendersSnapshotted?: boolean;
}


/**
 * @export
 */
export const HomeownershipTermsBlockResponseEnum = {
    Accepted: 'accepted',
    Declined: 'declined'
} as const;
export type HomeownershipTermsBlockResponseEnum = typeof HomeownershipTermsBlockResponseEnum[keyof typeof HomeownershipTermsBlockResponseEnum];

/**
 * @export
 */
export const HomeownershipTermsBlockAppraisalFeePayerEnum = {
    Buyer: 'buyer',
    Owner: 'owner'
} as const;
export type HomeownershipTermsBlockAppraisalFeePayerEnum = typeof HomeownershipTermsBlockAppraisalFeePayerEnum[keyof typeof HomeownershipTermsBlockAppraisalFeePayerEnum];


/**
 * Check if a given object implements the HomeownershipTermsBlock interface.
 */
export function instanceOfHomeownershipTermsBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function HomeownershipTermsBlockFromJSON(json: any): HomeownershipTermsBlock {
    return HomeownershipTermsBlockFromJSONTyped(json, false);
}

export function HomeownershipTermsBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipTermsBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'listPrice': !exists(json, 'list_price') ? undefined : json['list_price'],
        'residentPrice': !exists(json, 'resident_price') ? undefined : json['resident_price'],
        'closingCredit': !exists(json, 'closing_credit') ? undefined : json['closing_credit'],
        'discountPct': !exists(json, 'discount_pct') ? undefined : json['discount_pct'],
        'splitPct': !exists(json, 'split_pct') ? undefined : json['split_pct'],
        'validUntilDate': !exists(json, 'valid_until_date') ? undefined : json['valid_until_date'],
        'status': HomeownershipTermsStatusFromJSON(json['status']),
        'response': !exists(json, 'response') ? undefined : json['response'],
        'respondedAt': !exists(json, 'responded_at') ? undefined : (new Date(json['responded_at'])),
        'buyerAgentFeePct': !exists(json, 'buyer_agent_fee_pct') ? undefined : json['buyer_agent_fee_pct'],
        'buyerAgentFeeAmount': !exists(json, 'buyer_agent_fee_amount') ? undefined : json['buyer_agent_fee_amount'],
        'appraisalFeePayer': !exists(json, 'appraisal_fee_payer') ? undefined : json['appraisal_fee_payer'],
        'lenders': !exists(json, 'lenders') ? undefined : ((json['lenders'] as Array<any>).map(HomeownershipTermsLenderFromJSON)),
        'lendersSnapshotted': !exists(json, 'lenders_snapshotted') ? undefined : json['lenders_snapshotted'],
    };
}

export function HomeownershipTermsBlockToJSON(value?: HomeownershipTermsBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'list_price': value.listPrice,
        'resident_price': value.residentPrice,
        'closing_credit': value.closingCredit,
        'discount_pct': value.discountPct,
        'split_pct': value.splitPct,
        'valid_until_date': value.validUntilDate,
        'status': HomeownershipTermsStatusToJSON(value.status),
        'response': value.response,
        'responded_at': value.respondedAt === undefined ? undefined : (value.respondedAt.toISOString()),
        'buyer_agent_fee_pct': value.buyerAgentFeePct,
        'buyer_agent_fee_amount': value.buyerAgentFeeAmount,
        'appraisal_fee_payer': value.appraisalFeePayer,
        'lenders': value.lenders === undefined ? undefined : ((value.lenders as Array<any>).map(HomeownershipTermsLenderToJSON)),
        'lenders_snapshotted': value.lendersSnapshotted,
    };
}

